import { primary } from "./primary";
import { secondary } from "./secondary";

export const leftMenu = {
  backgroundColorMenu: primary[900],
  backgroundColorSelected: secondary[500],
  borderColorActive: secondary[700],
  borderColorInActive: secondary[200],
  textColorActive: primary[50],
  textColorInActive: primary[100],
  scrollbarThumb: primary[700],
};
